import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  async verifyCurrentTenant() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant()
    return await axios.post('', { query: `` })
  }
}
